type NavigatePayload = { readonly date: string };
type TaskPayload = { readonly taskId: string };

type DateListener = (payload: NavigatePayload) => void;
type TaskListener = (payload: TaskPayload) => void;

const dateListeners = new Set<DateListener>();
const taskListeners = new Set<TaskListener>();

let pendingDate: string | null = null;

export function onNavigateToDate(cb: DateListener): () => void {
  dateListeners.add(cb);
  // Flush pending navigation if the listener mounts after emit
  if (pendingDate !== null) {
    const date = pendingDate;
    pendingDate = null;
    cb({ date });
  }
  return () => dateListeners.delete(cb);
}

export function emitNavigateToDate(date: string): void {
  if (dateListeners.size === 0) {
    // No listener yet (calendar not mounted) — buffer it
    pendingDate = date;
    return;
  }
  for (const cb of dateListeners) cb({ date });
}

// Exposer sur window pour le bridge natif Android (widget → calendrier)
(window as unknown as Record<string, unknown>).__palniaNavigateToDate = emitNavigateToDate;

export function onHighlightTask(cb: TaskListener): () => void {
  taskListeners.add(cb);
  return () => taskListeners.delete(cb);
}

export function emitHighlightTask(taskId: string): void {
  for (const cb of taskListeners) cb({ taskId });
}
